/*
 * This file contains TypeScript enums and interfaces that map to the Exp API types.
 */

export enum MetricPeriodTypeCdEnum {
	YTD = 'YTD',
	LTM = 'LTM',
	L5Y = 'L5Y',
	MONTH = 'MONTH',
	YEAR = 'YEAR',
}

export enum PartyTypeCdEnum {
	AGENT = 'AGENT',
	OFFICE = 'OFFICE',
	BROKER = 'BROKER',
}

export enum MetricTypeCdEnum {
	TRXAM = 'TRXAM',
	GCI = 'GCI',
	LISTING = 'LISTING',
	RECRUIT = 'RECRUIT',
	SIDES = 'SIDES',
}

export enum GCICategoryCdEnum {
	_0M = '0M',
	_10M = '10M',
	_1M = '1M',
	_20M = '20M',
	_5M = '5M',
	UNK = 'UNK',
}

export enum ListingStatusCdEnum {
	ACTV = 'ACTV',
	CNCL = 'CNCL',
	EXPR = 'EXPR',
	PEND = 'PEND',
	PREL = 'PREL',
	WDRW = 'WDRW',
}

export enum RepFocusCdEnum {
	BAL = 'BAL',
	BUY = 'BUY',
	SELL = 'SELL',
}

export enum MLSActivityEventTypeCdEnum {
	ACTIVE = 'ACTIVE',
	PENDING = 'PENDING',
	SOLD = 'SOLD',
}

export enum ActivitySideCdEnum {
	BUY = 'BUY',
	SELL = 'SELL',
}

export enum RecruitingActivityTypeCdEnum {
	CALL = 'CALL',
	EMAIL = 'EMAIL',
	MEET = 'MEET',
	MSG = 'MSG',
	NOTE = 'NOTE',
}

export enum RecrActivityStatusCdEnum {
	COMPL = 'COMPL',
	SCHED = 'SCHED',
}

export enum SuggestionTypeCd {
	BRKGNM = 'BRKGNM',
	PRDAREA = 'PRDAREA',
	PRODUCTIONAREA = 'PRODUCTIONAREA',
}

/**
 * Brand codes for real estate franchises.
 */
export enum BrandCdEnum {
	/** Better Homes and Gardens Real Estate */
	BHG = 'BHG',
	/** Century 21 */
	C21 = 'C21',
	/** Coldwell Banker Commercial */
	CBC = 'CBC',
	/** Coldwell Banker Real Estate */
	CBR = 'CBR',
	/** Corcoran */
	COR = 'COR',
	/** ERA */
	ERA = 'ERA',
	/** Sotheby's International Realty */
	SIR = 'SIR',
	/** Unknown - value from the source does not map to a known value */
	UNK = 'UNK',
}

export enum BrokeragePersonStatusCdEnum {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	Active = 'Active',
	InActive = 'InActive',
}

export enum BrokeragePersonTypeCdEnum {
	AGENT = 'AGENT',
	STAFF = 'STAFF',
}

export enum PipelineTypeCdEnum {
	ACTIVE = 'ACTIVE',
	PASSIVE = 'PASSIVE',
	Active = 'Active',
	Passive = 'Passive',
}

export enum StageCdEnum {
	ARCH = 'ARCH', // Archived
	NURT = 'NURT', // Nurture
	IDEN = 'IDEN', // Identified
	CNCT = 'CNCT', // Contact Initiated
	MEET = 'MEET', // Meeting & Engaging
	NEGO = 'NEGO', // Negotiating
	CONV = 'CONV', // Converted
}

export enum StageNmEnum {
	Archived = 'Archived',
	Nurture = 'Nurture',
	Identified = 'Identified',
	ContactInitiated = 'Contact Initiated',
	MeetingEngaging = 'Meeting Engaging',
	Negotiating = 'Negotiating',
}

/**
 * Affiliation type codes for brokerage relationships.
 */
export enum AffiliationCdEnum {
	/** Franchise affiliation */
	FRCH = 'FRCH',
	/** Own affiliation */
	OWN = 'OWN',
	/** Unknown affiliation */
	UNK = 'UNK',
}

/**
 *  Performance prediction apex level codes.
 */
export enum PerformancePredictionApexLevelCdEnum {
	EXCL = 'EXCL',
	HIGH = 'HIGH',
	LOW = 'LOW',
}

export enum MlsStatusCdEnum {
	ACTV = 'ACTV',
	NACTV = 'NACTV',
}

export enum EngagementTabDisplayCdEnum {
	SHOW = 'SHOW',
	PART = 'PARTIAL',
	HIDE = 'HIDE',
}
